export enum Currency {
  /**
   * UAE Dirham
   */
  UaeDirham = "AED",
  /**
   * Afghani
   */
  Afghani = "AFN",
  /**
   * Lek
   */
  Lek = "ALL",
  /**
   * Armenian Dram
   */
  ArmenianDram = "AMD",
  /**
   * Netherlands Antillean Guilder
   */
  NetherlandsAntilleanGuilder = "ANG",
  /**
   * Kwanza
   */
  Kwanza = "AOA",
  /**
   * Argentine Peso
   */
  ArgentinePeso = "ARS",
  /**
   * Australian Dollar
   */
  AustralianDollar = "AUD",
  /**
   * Aruban Florin
   */
  ArubanFlorin = "AWG",
  /**
   * Azerbaijan Manat
   */
  AzerbaijanManat = "AZN",
  /**
   * Convertible Mark
   */
  ConvertibleMark = "BAM",
  /**
   * Barbados Dollar
   */
  BarbadosDollar = "BBD",
  /**
   * Taka
   */
  Taka = "BDT",
  /**
   * Bulgarian Lev
   */
  BulgarianLev = "BGN",
  /**
   * Bahraini Dinar
   */
  BahrainiDinar = "BHD",
  /**
   * Burundi Franc
   */
  BurundiFranc = "BIF",
  /**
   * Bermudian Dollar
   */
  BermudianDollar = "BMD",
  /**
   * Brunei Dollar
   */
  BruneiDollar = "BND",
  /**
   * Boliviano
   */
  Boliviano = "BOB",
  /**
   * Mvdol
   */
  Mvdol = "BOV",
  /**
   * Brazilian Real
   */
  BrazilianReal = "BRL",
  /**
   * Bahamian Dollar
   */
  BahamianDollar = "BSD",
  /**
   * Ngultrum
   */
  Ngultrum = "BTN",
  /**
   * Pula
   */
  Pula = "BWP",
  /**
   * Belarusian Ruble
   */
  BelarusianRuble = "BYN",
  /**
   * Belize Dollar
   */
  BelizeDollar = "BZD",
  /**
   * Canadian Dollar
   */
  CanadianDollar = "CAD",
  /**
   * Congolese Franc
   */
  CongoleseFranc = "CDF",
  /**
   * WIR Euro
   */
  WirEuro = "CHE",
  /**
   * Swiss Franc
   */
  SwissFranc = "CHF",
  /**
   * WIR Franc
   */
  WirFranc = "CHW",
  /**
   * Unidad de Fomento
   */
  UnidadDeFomento = "CLF",
  /**
   * Chilean Peso
   */
  ChileanPeso = "CLP",
  /**
   * Yuan Renminbi
   */
  YuanRenminbi = "CNY",
  /**
   * Colombian Peso
   */
  ColombianPeso = "COP",
  /**
   * Unidad de Valor Real
   */
  UnidadDeValorReal = "COU",
  /**
   * Costa Rican Colon
   */
  CostaRicanColon = "CRC",
  /**
   * Cuban Peso
   */
  CubanPeso = "CUP",
  /**
   * Cabo Verde Escudo
   */
  CaboVerdeEscudo = "CVE",
  /**
   * Czech Koruna
   */
  CzechKoruna = "CZK",
  /**
   * Djibouti Franc
   */
  DjiboutiFranc = "DJF",
  /**
   * Danish Krone
   */
  DanishKrone = "DKK",
  /**
   * Dominican Peso
   */
  DominicanPeso = "DOP",
  /**
   * Algerian Dinar
   */
  AlgerianDinar = "DZD",
  /**
   * Egyptian Pound
   */
  EgyptianPound = "EGP",
  /**
   * Nakfa
   */
  Nakfa = "ERN",
  /**
   * Ethiopian Birr
   */
  EthiopianBirr = "ETB",
  /**
   * Euro
   */
  Euro = "EUR",
  /**
   * Fiji Dollar
   */
  FijiDollar = "FJD",
  /**
   * Falkland Islands Pound
   */
  FalklandIslandsPound = "FKP",
  /**
   * Pound Sterling
   */
  PoundSterling = "GBP",
  /**
   * Lari
   */
  Lari = "GEL",
  /**
   * Ghana Cedi
   */
  GhanaCedi = "GHS",
  /**
   * Gibraltar Pound
   */
  GibraltarPound = "GIP",
  /**
   * Dalasi
   */
  Dalasi = "GMD",
  /**
   * Guinean Franc
   */
  GuineanFranc = "GNF",
  /**
   * Quetzal
   */
  Quetzal = "GTQ",
  /**
   * Guyana Dollar
   */
  GuyanaDollar = "GYD",
  /**
   * Hong Kong Dollar
   */
  HongKongDollar = "HKD",
  /**
   * Lempira
   */
  Lempira = "HNL",
  /**
   * Gourde
   */
  Gourde = "HTG",
  /**
   * Forint
   */
  Forint = "HUF",
  /**
   * Rupiah
   */
  Rupiah = "IDR",
  /**
   * New Israeli Sheqel
   */
  NewIsraeliSheqel = "ILS",
  /**
   * Indian Rupee
   */
  IndianRupee = "INR",
  /**
   * Iraqi Dinar
   */
  IraqiDinar = "IQD",
  /**
   * Iranian Rial
   */
  IranianRial = "IRR",
  /**
   * Iceland Krona
   */
  IcelandKrona = "ISK",
  /**
   * Jamaican Dollar
   */
  JamaicanDollar = "JMD",
  /**
   * Jordanian Dinar
   */
  JordanianDinar = "JOD",
  /**
   * Yen
   */
  Yen = "JPY",
  /**
   * Kenyan Shilling
   */
  KenyanShilling = "KES",
  /**
   * Som
   */
  Som = "KGS",
  /**
   * Riel
   */
  Riel = "KHR",
  /**
   * Comorian Franc
   */
  ComorianFranc = "KMF",
  /**
   * North Korean Won
   */
  NorthKoreanWon = "KPW",
  /**
   * Won
   */
  Won = "KRW",
  /**
   * Kuwaiti Dinar
   */
  KuwaitiDinar = "KWD",
  /**
   * Cayman Islands Dollar
   */
  CaymanIslandsDollar = "KYD",
  /**
   * Tenge
   */
  Tenge = "KZT",
  /**
   * Lao Kip
   */
  LaoKip = "LAK",
  /**
   * Lebanese Pound
   */
  LebanesePound = "LBP",
  /**
   * Sri Lanka Rupee
   */
  SriLankaRupee = "LKR",
  /**
   * Liberian Dollar
   */
  LiberianDollar = "LRD",
  /**
   * Loti
   */
  Loti = "LSL",
  /**
   * Libyan Dinar
   */
  LibyanDinar = "LYD",
  /**
   * Moroccan Dirham
   */
  MoroccanDirham = "MAD",
  /**
   * Moldovan Leu
   */
  MoldovanLeu = "MDL",
  /**
   * Malagasy Ariary
   */
  MalagasyAriary = "MGA",
  /**
   * Denar
   */
  Denar = "MKD",
  /**
   * Kyat
   */
  Kyat = "MMK",
  /**
   * Tugrik
   */
  Tugrik = "MNT",
  /**
   * Pataca
   */
  Pataca = "MOP",
  /**
   * Ouguiya
   */
  Ouguiya = "MRU",
  /**
   * Mauritius Rupee
   */
  MauritiusRupee = "MUR",
  /**
   * Rufiyaa
   */
  Rufiyaa = "MVR",
  /**
   * Malawi Kwacha
   */
  MalawiKwacha = "MWK",
  /**
   * Mexican Peso
   */
  MexicanPeso = "MXN",
  /**
   * Mexican Unidad de Inversion (UDI)
   */
  MexicanUnidadDeInversionUdi = "MXV",
  /**
   * Malaysian Ringgit
   */
  MalaysianRinggit = "MYR",
  /**
   * Mozambique Metical
   */
  MozambiqueMetical = "MZN",
  /**
   * Namibia Dollar
   */
  NamibiaDollar = "NAD",
  /**
   * Naira
   */
  Naira = "NGN",
  /**
   * Cordoba Oro
   */
  CordobaOro = "NIO",
  /**
   * Norwegian Krone
   */
  NorwegianKrone = "NOK",
  /**
   * Nepalese Rupee
   */
  NepaleseRupee = "NPR",
  /**
   * New Zealand Dollar
   */
  NewZealandDollar = "NZD",
  /**
   * Rial Omani
   */
  RialOmani = "OMR",
  /**
   * Balboa
   */
  Balboa = "PAB",
  /**
   * Sol
   */
  Sol = "PEN",
  /**
   * Kina
   */
  Kina = "PGK",
  /**
   * Philippine Peso
   */
  PhilippinePeso = "PHP",
  /**
   * Pakistan Rupee
   */
  PakistanRupee = "PKR",
  /**
   * Zloty
   */
  Zloty = "PLN",
  /**
   * Guarani
   */
  Guarani = "PYG",
  /**
   * Qatari Rial
   */
  QatariRial = "QAR",
  /**
   * Romanian Leu
   */
  RomanianLeu = "RON",
  /**
   * Serbian Dinar
   */
  SerbianDinar = "RSD",
  /**
   * Russian Ruble
   */
  RussianRuble = "RUB",
  /**
   * Rwanda Franc
   */
  RwandaFranc = "RWF",
  /**
   * Saudi Riyal
   */
  SaudiRiyal = "SAR",
  /**
   * Solomon Islands Dollar
   */
  SolomonIslandsDollar = "SBD",
  /**
   * Seychelles Rupee
   */
  SeychellesRupee = "SCR",
  /**
   * Sudanese Pound
   */
  SudanesePound = "SDG",
  /**
   * Swedish Krona
   */
  SwedishKrona = "SEK",
  /**
   * Singapore Dollar
   */
  SingaporeDollar = "SGD",
  /**
   * Saint Helena Pound
   */
  SaintHelenaPound = "SHP",
  /**
   * Sierra Leone (new valuation 2022)
   */
  SierraLeoneNewValuation2022 = "SLE",
  /**
   * Somali Shilling
   */
  SomaliShilling = "SOS",
  /**
   * Surinam Dollar
   */
  SurinamDollar = "SRD",
  /**
   * South Sudanese Pound
   */
  SouthSudanesePound = "SSP",
  /**
   * Dobra
   */
  Dobra = "STN",
  /**
   * El Salvador Colon
   */
  ElSalvadorColon = "SVC",
  /**
   * Syrian Pound
   */
  SyrianPound = "SYP",
  /**
   * Lilangeni
   */
  Lilangeni = "SZL",
  /**
   * Baht
   */
  Baht = "THB",
  /**
   * Somoni
   */
  Somoni = "TJS",
  /**
   * Turkmenistan New Manat
   */
  TurkmenistanNewManat = "TMT",
  /**
   * Tunisian Dinar
   */
  TunisianDinar = "TND",
  /**
   * Pa’anga
   */
  PaAnga = "TOP",
  /**
   * Turkish Lira
   */
  TurkishLira = "TRY",
  /**
   * Trinidad and Tobago Dollar
   */
  TrinidadAndTobagoDollar = "TTD",
  /**
   * New Taiwan Dollar
   */
  NewTaiwanDollar = "TWD",
  /**
   * Tanzanian Shilling
   */
  TanzanianShilling = "TZS",
  /**
   * Hryvnia
   */
  Hryvnia = "UAH",
  /**
   * Uganda Shilling
   */
  UgandaShilling = "UGX",
  /**
   * US Dollar
   */
  UsDollar = "USD",
  /**
   * US Dollar (Next day)
   */
  UsDollarNextDay = "USN",
  /**
   * Uruguay Peso en Unidades Indexadas (UI)
   */
  UruguayPesoEnUnidadesIndexadasUi = "UYI",
  /**
   * Peso Uruguayo
   */
  PesoUruguayo = "UYU",
  /**
   * Unidad Previsional
   */
  UnidadPrevisional = "UYW",
  /**
   * Uzbekistan Sum
   */
  UzbekistanSum = "UZS",
  /**
   * Bolívar Soberano, new valuation
   */
  BolívarSoberanoNewValuation = "VED",
  /**
   * Bolívar Soberano
   */
  BolívarSoberano = "VES",
  /**
   * Dong
   */
  Dong = "VND",
  /**
   * Vatu
   */
  Vatu = "VUV",
  /**
   * Tala
   */
  Tala = "WST",
  /**
   * CFA Franc BEAC
   */
  CfaFrancBeac = "XAF",
  /**
   * Silver
   */
  Silver = "XAG",
  /**
   * Gold
   */
  Gold = "XAU",
  /**
   * Bond Markets Unit European Composite Unit (EURCO)
   */
  BondMarketsUnitEuropeanCompositeUnitEurco = "XBA",
  /**
   * Bond Markets Unit European Monetary Unit (E.M.U.-6)
   */
  BondMarketsUnitEuropeanMonetaryUnitEMU6 = "XBB",
  /**
   * Bond Markets Unit European Unit of Account 9 (E.U.A.-9)
   */
  BondMarketsUnitEuropeanUnitAccount9EUA9 = "XBC",
  /**
   * Bond Markets Unit European Unit of Account 17 (E.U.A.-17)
   */
  BondMarketsUnitEuropeanUnitAccount17EUA17 = "XBD",
  /**
   * East Caribbean Dollar
   */
  EastCaribbeanDollar = "XCD",
  /**
   * SDR (Special Drawing Right)
   */
  SdrSpecialDrawingRight = "XDR",
  /**
   * CFA Franc BCEAO
   */
  CfaFrancBceao = "XOF",
  /**
   * Palladium
   */
  Palladium = "XPD",
  /**
   * CFP Franc
   */
  CfpFranc = "XPF",
  /**
   * Platinum
   */
  Platinum = "XPT",
  /**
   * Sucre
   */
  Sucre = "XSU",
  /**
   * Codes specifically reserved for testing purposes
   */
  CodesSpecificallyReservedForTestingPurposes = "XTS",
  /**
   * ADB Unit of Account
   */
  AdbUnitAccount = "XUA",
  /**
   * The codes assigned for transactions where no currency is involved
   */
  TheCodesAssignedForTransactionsWhereNoCurrencyIsInvolved = "XXX",
  /**
   * Yemeni Rial
   */
  YemeniRial = "YER",
  /**
   * Rand
   */
  Rand = "ZAR",
  /**
   * Zambian Kwacha
   */
  ZambianKwacha = "ZMW",
  /**
   * Zimbabwe Gold
   */
  ZimbabweGold = "ZWG",
}

export function description(value: Currency): string {
  switch (value) {
    case Currency.UaeDirham:
      return "UAE Dirham";
    case Currency.Afghani:
      return "Afghani";
    case Currency.Lek:
      return "Lek";
    case Currency.ArmenianDram:
      return "Armenian Dram";
    case Currency.NetherlandsAntilleanGuilder:
      return "Netherlands Antillean Guilder";
    case Currency.Kwanza:
      return "Kwanza";
    case Currency.ArgentinePeso:
      return "Argentine Peso";
    case Currency.AustralianDollar:
      return "Australian Dollar";
    case Currency.ArubanFlorin:
      return "Aruban Florin";
    case Currency.AzerbaijanManat:
      return "Azerbaijan Manat";
    case Currency.ConvertibleMark:
      return "Convertible Mark";
    case Currency.BarbadosDollar:
      return "Barbados Dollar";
    case Currency.Taka:
      return "Taka";
    case Currency.BulgarianLev:
      return "Bulgarian Lev";
    case Currency.BahrainiDinar:
      return "Bahraini Dinar";
    case Currency.BurundiFranc:
      return "Burundi Franc";
    case Currency.BermudianDollar:
      return "Bermudian Dollar";
    case Currency.BruneiDollar:
      return "Brunei Dollar";
    case Currency.Boliviano:
      return "Boliviano";
    case Currency.Mvdol:
      return "Mvdol";
    case Currency.BrazilianReal:
      return "Brazilian Real";
    case Currency.BahamianDollar:
      return "Bahamian Dollar";
    case Currency.Ngultrum:
      return "Ngultrum";
    case Currency.Pula:
      return "Pula";
    case Currency.BelarusianRuble:
      return "Belarusian Ruble";
    case Currency.BelizeDollar:
      return "Belize Dollar";
    case Currency.CanadianDollar:
      return "Canadian Dollar";
    case Currency.CongoleseFranc:
      return "Congolese Franc";
    case Currency.WirEuro:
      return "WIR Euro";
    case Currency.SwissFranc:
      return "Swiss Franc";
    case Currency.WirFranc:
      return "WIR Franc";
    case Currency.UnidadDeFomento:
      return "Unidad de Fomento";
    case Currency.ChileanPeso:
      return "Chilean Peso";
    case Currency.YuanRenminbi:
      return "Yuan Renminbi";
    case Currency.ColombianPeso:
      return "Colombian Peso";
    case Currency.UnidadDeValorReal:
      return "Unidad de Valor Real";
    case Currency.CostaRicanColon:
      return "Costa Rican Colon";
    case Currency.CubanPeso:
      return "Cuban Peso";
    case Currency.CaboVerdeEscudo:
      return "Cabo Verde Escudo";
    case Currency.CzechKoruna:
      return "Czech Koruna";
    case Currency.DjiboutiFranc:
      return "Djibouti Franc";
    case Currency.DanishKrone:
      return "Danish Krone";
    case Currency.DominicanPeso:
      return "Dominican Peso";
    case Currency.AlgerianDinar:
      return "Algerian Dinar";
    case Currency.EgyptianPound:
      return "Egyptian Pound";
    case Currency.Nakfa:
      return "Nakfa";
    case Currency.EthiopianBirr:
      return "Ethiopian Birr";
    case Currency.Euro:
      return "Euro";
    case Currency.FijiDollar:
      return "Fiji Dollar";
    case Currency.FalklandIslandsPound:
      return "Falkland Islands Pound";
    case Currency.PoundSterling:
      return "Pound Sterling";
    case Currency.Lari:
      return "Lari";
    case Currency.GhanaCedi:
      return "Ghana Cedi";
    case Currency.GibraltarPound:
      return "Gibraltar Pound";
    case Currency.Dalasi:
      return "Dalasi";
    case Currency.GuineanFranc:
      return "Guinean Franc";
    case Currency.Quetzal:
      return "Quetzal";
    case Currency.GuyanaDollar:
      return "Guyana Dollar";
    case Currency.HongKongDollar:
      return "Hong Kong Dollar";
    case Currency.Lempira:
      return "Lempira";
    case Currency.Gourde:
      return "Gourde";
    case Currency.Forint:
      return "Forint";
    case Currency.Rupiah:
      return "Rupiah";
    case Currency.NewIsraeliSheqel:
      return "New Israeli Sheqel";
    case Currency.IndianRupee:
      return "Indian Rupee";
    case Currency.IraqiDinar:
      return "Iraqi Dinar";
    case Currency.IranianRial:
      return "Iranian Rial";
    case Currency.IcelandKrona:
      return "Iceland Krona";
    case Currency.JamaicanDollar:
      return "Jamaican Dollar";
    case Currency.JordanianDinar:
      return "Jordanian Dinar";
    case Currency.Yen:
      return "Yen";
    case Currency.KenyanShilling:
      return "Kenyan Shilling";
    case Currency.Som:
      return "Som";
    case Currency.Riel:
      return "Riel";
    case Currency.ComorianFranc:
      return "Comorian Franc ";
    case Currency.NorthKoreanWon:
      return "North Korean Won";
    case Currency.Won:
      return "Won";
    case Currency.KuwaitiDinar:
      return "Kuwaiti Dinar";
    case Currency.CaymanIslandsDollar:
      return "Cayman Islands Dollar";
    case Currency.Tenge:
      return "Tenge";
    case Currency.LaoKip:
      return "Lao Kip";
    case Currency.LebanesePound:
      return "Lebanese Pound";
    case Currency.SriLankaRupee:
      return "Sri Lanka Rupee";
    case Currency.LiberianDollar:
      return "Liberian Dollar";
    case Currency.Loti:
      return "Loti";
    case Currency.LibyanDinar:
      return "Libyan Dinar";
    case Currency.MoroccanDirham:
      return "Moroccan Dirham";
    case Currency.MoldovanLeu:
      return "Moldovan Leu";
    case Currency.MalagasyAriary:
      return "Malagasy Ariary";
    case Currency.Denar:
      return "Denar";
    case Currency.Kyat:
      return "Kyat";
    case Currency.Tugrik:
      return "Tugrik";
    case Currency.Pataca:
      return "Pataca";
    case Currency.Ouguiya:
      return "Ouguiya";
    case Currency.MauritiusRupee:
      return "Mauritius Rupee";
    case Currency.Rufiyaa:
      return "Rufiyaa";
    case Currency.MalawiKwacha:
      return "Malawi Kwacha";
    case Currency.MexicanPeso:
      return "Mexican Peso";
    case Currency.MexicanUnidadDeInversionUdi:
      return "Mexican Unidad de Inversion (UDI)";
    case Currency.MalaysianRinggit:
      return "Malaysian Ringgit";
    case Currency.MozambiqueMetical:
      return "Mozambique Metical";
    case Currency.NamibiaDollar:
      return "Namibia Dollar";
    case Currency.Naira:
      return "Naira";
    case Currency.CordobaOro:
      return "Cordoba Oro";
    case Currency.NorwegianKrone:
      return "Norwegian Krone";
    case Currency.NepaleseRupee:
      return "Nepalese Rupee";
    case Currency.NewZealandDollar:
      return "New Zealand Dollar";
    case Currency.RialOmani:
      return "Rial Omani";
    case Currency.Balboa:
      return "Balboa";
    case Currency.Sol:
      return "Sol";
    case Currency.Kina:
      return "Kina";
    case Currency.PhilippinePeso:
      return "Philippine Peso";
    case Currency.PakistanRupee:
      return "Pakistan Rupee";
    case Currency.Zloty:
      return "Zloty";
    case Currency.Guarani:
      return "Guarani";
    case Currency.QatariRial:
      return "Qatari Rial";
    case Currency.RomanianLeu:
      return "Romanian Leu";
    case Currency.SerbianDinar:
      return "Serbian Dinar";
    case Currency.RussianRuble:
      return "Russian Ruble";
    case Currency.RwandaFranc:
      return "Rwanda Franc";
    case Currency.SaudiRiyal:
      return "Saudi Riyal";
    case Currency.SolomonIslandsDollar:
      return "Solomon Islands Dollar";
    case Currency.SeychellesRupee:
      return "Seychelles Rupee";
    case Currency.SudanesePound:
      return "Sudanese Pound";
    case Currency.SwedishKrona:
      return "Swedish Krona";
    case Currency.SingaporeDollar:
      return "Singapore Dollar";
    case Currency.SaintHelenaPound:
      return "Saint Helena Pound";
    case Currency.SierraLeoneNewValuation2022:
      return "Sierra Leone (new valuation 2022)";
    case Currency.SomaliShilling:
      return "Somali Shilling";
    case Currency.SurinamDollar:
      return "Surinam Dollar";
    case Currency.SouthSudanesePound:
      return "South Sudanese Pound";
    case Currency.Dobra:
      return "Dobra";
    case Currency.ElSalvadorColon:
      return "El Salvador Colon";
    case Currency.SyrianPound:
      return "Syrian Pound";
    case Currency.Lilangeni:
      return "Lilangeni";
    case Currency.Baht:
      return "Baht";
    case Currency.Somoni:
      return "Somoni";
    case Currency.TurkmenistanNewManat:
      return "Turkmenistan New Manat";
    case Currency.TunisianDinar:
      return "Tunisian Dinar";
    case Currency.PaAnga:
      return "Pa’anga";
    case Currency.TurkishLira:
      return "Turkish Lira";
    case Currency.TrinidadAndTobagoDollar:
      return "Trinidad and Tobago Dollar";
    case Currency.NewTaiwanDollar:
      return "New Taiwan Dollar";
    case Currency.TanzanianShilling:
      return "Tanzanian Shilling";
    case Currency.Hryvnia:
      return "Hryvnia";
    case Currency.UgandaShilling:
      return "Uganda Shilling";
    case Currency.UsDollar:
      return "US Dollar";
    case Currency.UsDollarNextDay:
      return "US Dollar (Next day)";
    case Currency.UruguayPesoEnUnidadesIndexadasUi:
      return "Uruguay Peso en Unidades Indexadas (UI)";
    case Currency.PesoUruguayo:
      return "Peso Uruguayo";
    case Currency.UnidadPrevisional:
      return "Unidad Previsional";
    case Currency.UzbekistanSum:
      return "Uzbekistan Sum";
    case Currency.BolívarSoberanoNewValuation:
      return "Bolívar Soberano, new valuation";
    case Currency.BolívarSoberano:
      return "Bolívar Soberano";
    case Currency.Dong:
      return "Dong";
    case Currency.Vatu:
      return "Vatu";
    case Currency.Tala:
      return "Tala";
    case Currency.CfaFrancBeac:
      return "CFA Franc BEAC";
    case Currency.Silver:
      return "Silver";
    case Currency.Gold:
      return "Gold";
    case Currency.BondMarketsUnitEuropeanCompositeUnitEurco:
      return "Bond Markets Unit European Composite Unit (EURCO)";
    case Currency.BondMarketsUnitEuropeanMonetaryUnitEMU6:
      return "Bond Markets Unit European Monetary Unit (E.M.U.-6)";
    case Currency.BondMarketsUnitEuropeanUnitAccount9EUA9:
      return "Bond Markets Unit European Unit of Account 9 (E.U.A.-9)";
    case Currency.BondMarketsUnitEuropeanUnitAccount17EUA17:
      return "Bond Markets Unit European Unit of Account 17 (E.U.A.-17)";
    case Currency.EastCaribbeanDollar:
      return "East Caribbean Dollar";
    case Currency.SdrSpecialDrawingRight:
      return "SDR (Special Drawing Right)";
    case Currency.CfaFrancBceao:
      return "CFA Franc BCEAO";
    case Currency.Palladium:
      return "Palladium";
    case Currency.CfpFranc:
      return "CFP Franc";
    case Currency.Platinum:
      return "Platinum";
    case Currency.Sucre:
      return "Sucre";
    case Currency.CodesSpecificallyReservedForTestingPurposes:
      return "Codes specifically reserved for testing purposes";
    case Currency.AdbUnitAccount:
      return "ADB Unit of Account";
    case Currency.TheCodesAssignedForTransactionsWhereNoCurrencyIsInvolved:
      return "The codes assigned for transactions where no currency is involved";
    case Currency.YemeniRial:
      return "Yemeni Rial";
    case Currency.Rand:
      return "Rand";
    case Currency.ZambianKwacha:
      return "Zambian Kwacha";
    case Currency.ZimbabweGold:
      return "Zimbabwe Gold";
  }
}
